import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-thunder-storm-sidebar',
  templateUrl: './thunder-storm-sidebar.component.html',
  styleUrls: ['./thunder-storm-sidebar.component.scss']
})
export class ThunderStormSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  isInitialLoad: boolean = false;
  queryParams: {};
  selected: string;
  dateIndexLength: any;
  activeRadioList: boolean[] = [];

  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router) {
    this.selected = this.router.url.split("/")[2]
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.dateIndexLength = this.queryParams['forecastLength'] == '24' ? 9 : 7
        for (let i = 0; i < this.dateIndexLength; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
        this.requestSelectedFilterParams()
      }
    })
  }

  ngOnChanges(change: SimpleChanges) {
    // let timeStamp = this.labelStrings[this.blockNum].groupName;
    // this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'THUNDERSTORM';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
    }
    if (this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

}
